import React, { useState } from "react";
import { myGlobals, myUtilities } from "../Utils";

import { Subscribe } from "unstated";
import ModernAChForm from "./ModernACHForm";
import PaymentMethodButton from "./PaymentMethodButton";
import InvoiceDataContainer from "../Stores/InvoiceDataContainerStore";
import { makeFirstCardCall } from "../Utils/AjaxUtil";
import PaymentDataContainer from "../Stores/PaymentDataContainerStore";
import { CreditCardPaymentDIPage, PaymentLoader } from "../Components/Payment";
import CCProcessor from "../Components/CCProcessor";
import CardCheckBox from "./CardCheckBox";
import { globalVars, callReduxAlertAction } from "../App";
import { AlertDialog } from "../Components/Common";
import AlertDropdown from "../Components/Common/AlertDropdown";
import { PAYMENT_METHOD_CC, PAYMENt_METHOD_DC } from "../Utils/utils";
import StaticLoader from "../Components/Common/StaticLoader";
import AlertConfirmDialog from "../Components/Common/AlertConfirmDialog";

const PaymentMethodsUX = (props) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('default');
  const [paymentStatus, setPaymentStatus] = useState("default");
  const [isTermsSelected, setIsTermsSelected] = useState(false);

  const onPayMethodClick = async (type, payData, invdata) => {
    await payData.isDCFlow(type === "dc");
    setIsTermsSelected(false);
    setSelectedPaymentMethod(type);
    await invdata.setState({toLoadCardDI: false});
    myGlobals.invoiceSelectionAllowed = false;
    globalVars.isTermsSelected = false;
    if (document.getElementById("myGlitchedCheckbox") !== null)
      document.getElementById("myGlitchedCheckbox").checked = false;
    //reset conv fee & late fee
    payData.setTotalConvenienceFeeAndSurcharge(null, null);
    payData.setTotalLateFee(null);
    myGlobals.paymentMethod = type;
    if (type === "cc" || type === "dc") {
	    let response = myUtilities.checkTransactionLimit(
	    	      myGlobals.isDCFlow ? "DEBITCARD" : "CREDITCARD",
	    	      invdata
	    	    );
		if(response !== 0) {
			    myGlobals.resetPaymentMethods();
			    myGlobals.invoiceSelectionAllowed = true;
			    return;
		}
    }
    if (
      (type === "cc" && invdata.state.CC_routingBasedOnPaymentInstrument) ||
      (type === "dc" && invdata.state.DC_routingBasedOnPaymentInstrument)
    )
        invdata.makeDropdownCallForCardTypes(type === "cc" ? PAYMENT_METHOD_CC : PAYMENt_METHOD_DC);
    else callAfterCardTypeSelect(payData, invdata, type);
  };
  
  myGlobals.selectedStateMethodPaymentContainer = (type) => setPaymentStatus(type);
  
  myGlobals.resetPaymentMethods = () => {
	    setSelectedPaymentMethod('default');
	    setPaymentStatus('default');
  }

  const postBackFunc = async (invdata, payData, type) => {
	    let resp = null;
	    await payData.setState({loadingPaymentStatus: true});
	    setPaymentStatus('LOADING');
	    if (type === "cc" || type === "dc" || type === "CREDITCARD" || type === "DEBITCARD") {
	      resp = await makeFirstCardCall(invdata, payData);
	      await invdata.cardResponseHandler(resp, payData);
	  }
	  await payData.setState({loadingPaymentStatus: false});
  };

  const callAfterCardTypeSelect = (paymentData, invdata, type) => {
    if (myGlobals.isDiscountEnabled || (invdata.state.isLateFeeEnabled && !invdata.state.paymentOnAccount))
      invdata.makeDiscountOrLateFeeCallForPaymentMethod(paymentData, type, postBackFunc);
    else postBackFunc(invdata, paymentData, type);
  };

  return (
    <Subscribe to={[PaymentDataContainer]}>
      {(payData) => (
        <Subscribe to={[InvoiceDataContainer]}>
          {(invdata) => (
            <>
            {invdata.state.showStaticLoading &&  <StaticLoader/> }
            <div>
              <div className="payment-method common-div">
                {myUtilities.accountSpecificLanguage(
                  "Payment.Container.Header.Payment.Details",
                  "Payment Details"
                )}
              </div>
              <p className="no-margin">{myUtilities.accountSpecificLanguage(
                      "generic.ModernUUX.PaymentDetailsSub",
                      "Please select a payment method to continue"
                    )}</p>
              <AlertDialog />
              <div className="payment-btn-container">
                {invdata.state.isAchEnabled && (
                  <PaymentMethodButton
                    callBack={(type) =>
                      onPayMethodClick(type, payData, invdata)
                    }
                    type="ach"
                    selectedPaymentMethod={selectedPaymentMethod}
                  />
                )}
                {invdata.state.isCCEnabled && (
                  <PaymentMethodButton
                    callBack={(type) =>
                      onPayMethodClick(type, payData, invdata)
                    }
                    type="cc"
                    selectedPaymentMethod={selectedPaymentMethod}
                  />
                )}
                {invdata.state.isDCEnabled && (
                  <PaymentMethodButton
                    callBack={(type) =>
                      onPayMethodClick(type, payData, invdata)
                    }
                    type="dc"
                    selectedPaymentMethod={selectedPaymentMethod}
                  />
                )}
              </div>
              {invdata.state.isAchEnabled &&
                selectedPaymentMethod === "ach" && <ModernAChForm toShowTncForPayment={invdata.state.toShowTncForPayment} isAch={true} invoiceDataState={invdata.state} payDataState={payData.state} key={"modernACH" + invdata.state.resetNum} />}
              {invdata.state.isAchEnabled && selectedPaymentMethod === "default"   &&  <ModernAChForm toShowTncForPayment={invdata.state.toShowTncForPayment} isAch={false} invoiceDataState={invdata.state} payDataState={payData.state} key={"modernACH" + invdata.state.resetNum} />}
              {(invdata.state.isDCEnabled || invdata.state.isCCEnabled) &&
                  invdata.state.toLoadCardDI &&
                  selectedPaymentMethod !== "default" && (
                    <>
	                  <CardCheckBox
	                    invData={invdata}
	                    payMethod={selectedPaymentMethod}
	                    callback={setIsTermsSelected}
	                  />
                    <div
                    className={`cont-${isTermsSelected}-${invdata.state.toShowTncForPayment[selectedPaymentMethod]}`}
                    onClick={() => {
                      if (
                        invdata.state.toShowTncForPayment &&
                        invdata.state.toShowTncForPayment[
                          selectedPaymentMethod
                        ] &&
                        !isTermsSelected
                      ) {
                        callReduxAlertAction(
                          "Error.ChooseTnCModernUX",
                          "Please check the terms and conditions at the top of the page to proceed with payment."
                        );
                      }
                    }}
                  >
                      {isTermsSelected && <CreditCardPaymentDIPage />}
                      </div>
                      
                    </>
                  )}
              {paymentStatus === "PROCESSING" && <CCProcessor paymentData={payData} invData={invdata} />}
              {paymentStatus === "LOADING" && <PaymentLoader/>}
            </div>
            <AlertDropdown invData={invdata} paymentData={payData} onClickConfirm={callAfterCardTypeSelect} />
            <AlertConfirmDialog
                          onAlertConfirmDialogClick={myGlobals.handleConfirmClick}/>
            </>
          )}
        </Subscribe>
      )}
    </Subscribe>
  );
};

export default PaymentMethodsUX;
